import { addUTMData, trackLeadToPensieve } from './utils/helpers';
import { BasePayload } from './types';

/**
 * Track the first step of signup via the email & login process.
 * Sends a lead to Pensieve with name, email, country, and UTM data.
 */
export const signupInitiatedTracking = (formData: BasePayload) => {
  const { firstName, lastName, email, country, referralCode, referralCompanyID } = formData;

  const baseData = {
    firstName,
    lastName,
    email,
    country,
    referralCode,
    referralCompanyID,
    get_address: true,
    company: {
      name: email,
    },
  };

  const dataWithUTM = addUTMData(baseData);
  trackLeadToPensieve(dataWithUTM);
};

export const splitFullName = (fullName: string | undefined) => {
  if (!fullName) return { firstName: undefined, lastName: undefined };

  const splitName = fullName.split(' ');

  return {
    firstName: splitName[0],
    lastName: splitName.slice(1).join(' ') || undefined,
  };
};
